import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { SerieListTable } from './components/serie-list-table';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Fragment } from 'react/jsx-runtime';
import { useSeriesListQuery } from '../queries';
import { querySchema } from './query-schema';
import { SerieListFilter } from './components/serie-list-filter';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);

  const { data, isLoading } = useSeriesListQuery({
    page_size: values.pageSize,
    ordering: values.ordering,
    page: values.pageIndex,
    search: values.search,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Serier" />
        <PageLayout.Context items={[<ContextMenu.Item label="Skapa serie" to="create" key="create" />]} />
      </PageLayout.Header>

      <PageLayout.Section>
        <SerieListFilter />
        <SerieListTable series={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
